// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2GPoc","productName":"Table_productName__2JuPH"};